import { render, staticRenderFns } from "./GrupoProdutoModal.vue?vue&type=template&id=48042286&scoped=true"
import script from "./GrupoProdutoModal.vue?vue&type=script&lang=js"
export * from "./GrupoProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./GrupoProdutoModal.vue?vue&type=style&index=0&id=48042286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48042286",
  null
  
)

export default component.exports